var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoCircleOutline = function SvgInfoCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10a2 2 0 0 1 2 2v6a1 1 0 0 1-2 0v-6h-1a1 1 0 0 1 0-2zM12 5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 0a12.013 12.013 0 0 1 12 12A12 12 0 1 1 12 0m3.827 2.76A10.002 10.002 0 0 0 2.761 15.828 10 10 0 0 0 12 22a10.01 10.01 0 0 0 10-10 10 10 0 0 0-6.173-9.24",
    clipRule: "evenodd"
  })));
};
export default SvgInfoCircleOutline;